import { Controller } from "@hotwired/stimulus"

// Formats a US phone field as (734) 555-0123 while typing.
export default class extends Controller {
  connect() {
    this.format()
  }

  format() {
    this.element.value = this.pretty(this.digits())
  }

  digits() {
    let digits = this.element.value.replace(/\D/g, "")
    if (digits.length === 11 && digits.startsWith("1")) {
      digits = digits.slice(1)
    }
    return digits.slice(0, 10)
  }

  pretty(digits) {
    if (digits.length === 0) return ""
    if (digits.length < 4) return `(${digits}`
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }
}
